import { always } from 'ramda';

/**
 * A function that returns `undefined`.
 *
 * @func stubUndefined
 * @memberOf RA
 * @since {@link https://char0n.github.io/ramda-adjunct/1.0.0|v1.0.0}
 * @category Function
 * @sig ... -> undefined
 * @return {undefined}
 * @example
 *
 * RA.stubUndefined(); //=> undefined
 * RA.stubUndefined(1, 2, 3); //=> undefined
 */
var stubUndefined = /*#__PURE__*/always(void 0); // eslint-disable-line no-void

export default stubUndefined;


//////////////////
// WEBPACK FOOTER
// ./node_modules/ramda-adjunct/es/stubUndefined.js
// module id = 92
// module chunks = 0